import { ArrowRight } from "lucide-react";
import { useLandingActions } from "./useLandingActions";

export default function HeroSection() {
    const { signIn } = useLandingActions();
    return <header className="mz-hero" id="home">
        <div className="mz-container">
            <div className="mz-hero__grid">
                <div className="mz-hero__copy">
                    <p className="mz-eyebrow"><span />Complete career readiness platform</p>
                    <h1>From Campus to Career, with<br /><em>Confidence.</em></h1>
                    <p className="mz-hero__lead">Build real-world skills, gain practical experience, and prepare for the opportunities that shape your career.</p>
                    <div className="mz-hero__actions">
                        <button className="mz-button mz-button--primary mz-button--large" onClick={signIn}>Getting started <ArrowRight /></button>
                    </div>
                </div>
                <div className="mz-hero__visual">
                    <div className="mz-hero__backdrop" />
                    <img className="mz-hero__image" src="/images/jpg/public-hero-v2.webp" alt="South Indian college students preparing together for their careers" />
                    <div className="mz-hero__statement">
                        <p>Turn potential into <span>career readiness.</span></p>
                    </div>
                </div>
            </div>
        </div>
    </header>;
}
